module.exports = __webpack_public_path__ + "img/error.dd7466d6.svg";